import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MembershipStatus, MembershipSubscribeResult, MembershipTerm } from '../models';

import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class MembershipService {
  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  /**
   * Whether the signed-in user holds the Premium Stripe entitlement (UserSettings.isPremiumMember, resolved server-side).
   */
  public get isPremiumMember(): boolean {
    return !!this.userService.userSettings.value?.isPremiumMember;
  }

  /**
   * The signed-in member's own membership status, read from Stripe by OA.Web.
   */
  public getMembershipStatus(): Observable<MembershipStatus> {
    return this.http.get<MembershipStatus>('membership/status');
  }

  /**
   * Starts a Premium membership for the signed-in user. Returns what the Stripe Payment Element needs to collect
   * the first payment. Fails with 409 { code: 'already_premium' } when the user is already Premium.
   */
  public subscribe(plan: MembershipTerm): Observable<MembershipSubscribeResult> {
    return this.http.post<MembershipSubscribeResult>('membership/subscribe', { plan });
  }
}
